import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { canCreateCounterparty } from "./permissions";
import { useRoles } from "./useRoles";

type Props = {
  children: ReactNode;
};

export const RequireCreateCounterparty = ({ children }: Props) => {
  const roles = useRoles();

  if (!canCreateCounterparty(roles)) {
    return <Navigate to="/tradingcounterparties" replace />;
  }

  return children;
};
